import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './award-summary-wrap.styl'

class AwardSummaryWrap extends Component {
  static propTypes = {
    children: PropTypes.any
  }

  render() {
    return (
      <div className={styles.wrap}>
        {this.props.children}
      </div>
    )
  }
}

export default AwardSummaryWrap
